var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 146,
    viewBox: "0 0 320 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.397 138.576C224.666 138.458 224.895 138.201 225.039 137.856C225.182 137.512 225.23 137.103 225.174 136.711C225.117 136.318 224.96 135.97 224.732 135.733C224.505 135.496 224.224 135.389 223.944 135.431H95.3488C94.7818 135.431 94.314 135.975 94.2005 136.741C94.1487 137.111 94.1898 137.496 94.3168 137.827C94.4437 138.159 94.6484 138.417 94.8952 138.556L104.89 144.483C106.052 145.168 107.3 145.511 108.561 145.511H210.731C211.993 145.511 213.226 145.168 214.389 144.483L224.397 138.576Z",
    fill: "#C8CACB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.5957 135.84H320.401",
    stroke: "#090A0B",
    strokeWidth: 1.77349,
    strokeMiterlimit: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.83 111.172C325.83 111.172 314.177 121.813 295.705 116.918C277.389 112.094 274.129 127.247 254.707 121.799C237.284 116.918 229.359 129.687 218.415 129.176",
    stroke: "#090A0B",
    strokeWidth: 1.77349,
    strokeMiterlimit: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.297 130.609C90.2599 132.312 78.7203 123.345 69.2646 120.976C57.5548 118.11 53.2593 121.784 44.399 123.586C33.3414 125.502 26.0405 120.039 18.0025 116.109C7.95135 111.385 -6.04083 110.576 -18.1475 111.526C-31.6577 112.562 -44.5583 124.849 -62.9735 122.352C-75.7182 119.415 -93.538 118.323 -105.248 121.203C-114.689 123.572 -121.48 130.978 -133.927 130.609",
    stroke: "#090A0B",
    strokeWidth: 1.77349,
    strokeMiterlimit: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.752 26.2136H184.406L181.769 21.7444C180.561 19.6918 178.868 17.9677 176.839 16.7235C174.809 15.4792 172.505 14.7531 170.129 14.6087C167.753 14.4644 165.378 14.9064 163.213 15.8958C161.048 16.8852 159.159 18.3918 157.712 20.283L157.216 19.7439C155.874 18.3037 154.259 17.1456 152.465 16.3374C150.671 15.5291 148.734 15.087 146.767 15.0368C144.801 14.9866 142.844 15.3293 141.011 16.045C139.178 16.7606 137.506 17.8348 136.093 19.2048C136.093 19.2048 136.093 19.2048 136.093 19.2048L133.569 18.3535C131.658 17.7094 129.628 17.4975 127.625 17.733C125.623 17.9685 123.697 18.6456 121.987 19.7155C120.399 20.7641 118.708 21.6483 116.94 22.3545C114.538 23.2598 112.006 23.7724 109.441 23.8726",
    stroke: "#090A0B",
    strokeWidth: 1.77349,
    strokeMiterlimit: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.463 37.5906H284.676L282.719 34.1429C281.858 32.5879 280.623 31.2727 279.125 30.3163C277.627 29.36 275.915 28.7929 274.143 28.6664C272.371 28.5629 270.602 28.9077 268.999 29.6689C267.396 30.4302 266.011 31.5834 264.97 33.0221C264.97 33.0221 264.97 33.0221 264.97 33.0221L264.602 32.6107C263.631 31.5134 262.446 30.6265 261.119 30.0044C259.793 29.3822 258.354 29.038 256.89 28.9927C255.429 28.9606 253.977 29.2286 252.624 29.7801C251.271 30.3316 250.045 31.1549 249.022 32.1992C249.022 32.1992 249.022 32.1992 249.022 32.1992L247.165 31.5466C245.756 31.0508 244.252 30.8863 242.77 31.0659C241.287 31.2456 239.866 31.7644 238.616 32.5823C235.908 34.5283 232.69 35.6381 229.359 35.7746",
    stroke: "#090A0B",
    strokeWidth: 1.77349,
    strokeMiterlimit: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.704 127.241C197.775 127.497 205.615 127.241 205.615 127.241C205.615 127.241 213.156 124.999 214.234 124.262V137.031C214.234 137.996 213.44 138.79 212.462 138.79H199.476C199.006 138.79 198.555 138.603 198.223 138.271C197.891 137.938 197.704 137.487 197.704 137.017V127.227V127.241Z",
    fill: "#090A0B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.704 127.241C197.775 127.497 205.615 127.241 205.615 127.241C205.615 127.241 213.156 124.999 214.234 124.262V137.031C214.234 137.996 213.44 138.79 212.462 138.79H199.476C199.006 138.79 198.555 138.603 198.223 138.271C197.891 137.938 197.704 137.487 197.704 137.017V127.227V127.241Z",
    stroke: "#090A0B",
    strokeWidth: 1.77349,
    strokeMiterlimit: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.123 127.241C121.066 127.482 114.063 127.099 114.063 127.099C114.063 127.099 105.756 125.056 104.607 124.262V137.031C104.607 137.996 105.401 138.79 106.379 138.79H119.365C119.597 138.79 119.827 138.744 120.041 138.655C120.255 138.566 120.45 138.435 120.613 138.27C120.777 138.105 120.906 137.909 120.993 137.694C121.081 137.479 121.125 137.249 121.123 137.017V127.227V127.241Z",
    fill: "#090A0B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.123 127.241C121.066 127.482 114.063 127.099 114.063 127.099C114.063 127.099 105.756 125.056 104.607 124.262V137.031C104.607 137.996 105.401 138.79 106.379 138.79H119.365C119.597 138.79 119.827 138.744 120.041 138.655C120.255 138.566 120.45 138.435 120.613 138.27C120.777 138.105 120.906 137.909 120.993 137.694C121.081 137.479 121.125 137.249 121.123 137.017V127.227V127.241Z",
    stroke: "#090A0B",
    strokeWidth: 1.77349,
    strokeMiterlimit: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.629 100.327L218.544 116.387C218.536 118.349 217.883 120.253 216.687 121.807C215.491 123.361 213.817 124.478 211.923 124.985C208.181 125.978 204.24 127.057 204.24 127.057L159.414 128.078L114.602 127.057L106.904 124.985C105.011 124.478 103.337 123.361 102.141 121.807C100.944 120.253 100.292 118.349 100.284 116.387L100.213 100.312",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.629 100.327L218.544 116.387C218.536 118.349 217.883 120.253 216.687 121.807C215.491 123.361 213.817 124.478 211.923 124.985C208.181 125.978 204.24 127.057 204.24 127.057L159.414 128.078L114.602 127.057L106.904 124.985C105.011 124.478 103.337 123.361 102.141 121.807C100.944 120.253 100.292 118.349 100.284 116.387L100.213 100.312",
    stroke: "#090A0B",
    strokeWidth: 1.77349,
    strokeMiterlimit: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.491 85.4573C214.801 84.6486 214.659 79.3281 214.659 79.3281H201.418",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.491 85.4573C214.801 84.6486 214.659 79.3281 214.659 79.3281H201.418",
    stroke: "#090A0B",
    strokeWidth: 1.77349,
    strokeMiterlimit: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.349 85.4573C104.04 84.6486 104.167 79.3281 104.167 79.3281H117.422",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.349 85.4573C104.04 84.6486 104.167 79.3281 104.167 79.3281H117.422",
    stroke: "#090A0B",
    strokeWidth: 1.77349,
    strokeMiterlimit: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.589 85.2876L212.376 85.4863C212.844 85.4863 213.269 85.6991 213.581 86.0254C217.607 90.3953 218.883 94.1834 218.614 100.313L211.384 117.281C211.039 118.09 210.464 118.78 209.731 119.264C208.997 119.749 208.137 120.006 207.259 120.005H111.567C110.691 120.004 109.834 119.745 109.104 119.26C108.373 118.776 107.8 118.088 107.456 117.281L100.226 100.313C99.9427 94.1834 101.219 90.3811 105.259 86.0254C105.571 85.6991 105.996 85.5004 106.45 85.5004L119.251 85.2734",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.589 85.2876L212.376 85.4863C212.844 85.4863 213.269 85.6991 213.581 86.0254C217.607 90.3953 218.883 94.1834 218.614 100.313L211.384 117.281C211.039 118.09 210.464 118.78 209.731 119.264C208.997 119.749 208.137 120.006 207.259 120.005H111.567C110.691 120.004 109.834 119.745 109.104 119.26C108.373 118.776 107.8 118.088 107.456 117.281L100.226 100.313C99.9427 94.1834 101.219 90.3811 105.259 86.0254C105.571 85.6991 105.996 85.5004 106.45 85.5004L119.251 85.2734",
    stroke: "#090A0B",
    strokeWidth: 1.77349,
    strokeMiterlimit: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.704 92.25H211.469C211.605 92.2498 211.739 92.2795 211.862 92.337C211.985 92.3945 212.093 92.4784 212.18 92.5827C212.266 92.6871 212.329 92.8093 212.363 92.9406C212.397 93.0719 212.402 93.2091 212.377 93.3425L210.732 102.409C210.676 102.692 210.435 102.891 210.151 102.891H197.704",
    stroke: "#090A0B",
    strokeWidth: 1.77349,
    strokeMiterlimit: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.108 92.25H185.994V102.891H197.108V92.25Z",
    stroke: "#090A0B",
    strokeWidth: 1.77349,
    strokeMiterlimit: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.589 102.891H163.439C163.338 102.89 163.239 102.867 163.147 102.825C163.056 102.782 162.974 102.721 162.909 102.644C162.843 102.567 162.794 102.478 162.766 102.381C162.738 102.284 162.73 102.182 162.744 102.082C163.538 98.2373 168.528 92.25 174.567 92.25H186.589",
    stroke: "#090A0B",
    strokeWidth: 1.77349,
    strokeMiterlimit: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.931 108.977L170.641 120.44",
    stroke: "#090A0B",
    strokeWidth: 1.77349,
    strokeMiterlimit: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.123 92.2501H107.372C107.235 92.2478 107.1 92.2759 106.975 92.3325C106.851 92.3891 106.74 92.4727 106.652 92.5773C106.564 92.6819 106.5 92.8049 106.465 92.9373C106.43 93.0696 106.425 93.2081 106.45 93.3426L108.109 102.409C108.166 102.692 108.393 102.891 108.676 102.891H121.123",
    stroke: "#090A0B",
    strokeWidth: 1.77349,
    strokeMiterlimit: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.832 92.25H121.718V102.891H132.832V92.25Z",
    stroke: "#090A0B",
    strokeWidth: 1.77349,
    strokeMiterlimit: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.251 102.891H155.387C155.489 102.892 155.59 102.871 155.683 102.829C155.776 102.787 155.86 102.726 155.927 102.649C155.994 102.573 156.044 102.482 156.073 102.384C156.102 102.286 156.11 102.183 156.096 102.082C155.288 98.2373 150.312 92.25 144.273 92.25H132.251",
    stroke: "#090A0B",
    strokeWidth: 1.77349,
    strokeMiterlimit: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.2 108.977H124.567L125.914 115.602H135.2V108.977Z",
    stroke: "#090A0B",
    strokeWidth: 1.77349,
    strokeMiterlimit: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.199 115.605H147.604",
    stroke: "black",
    strokeWidth: 1.77349,
    strokeMiterlimit: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.527 108.977H194.16L192.813 115.602H183.527V108.977Z",
    stroke: "#090A0B",
    strokeWidth: 1.77349,
    strokeMiterlimit: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.527 115.605H171.123",
    stroke: "black",
    strokeWidth: 1.77349,
    strokeMiterlimit: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.185 120.327L146.909 108.977",
    stroke: "#090A0B",
    strokeWidth: 1.77349,
    strokeMiterlimit: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.371 108.977H211.114",
    stroke: "#090A0B",
    strokeWidth: 1.77349,
    strokeMiterlimit: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.265 111.223V117.565",
    stroke: "black",
    strokeWidth: 1.77349,
    strokeMiterlimit: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.71 111.223V117.565",
    stroke: "black",
    strokeWidth: 1.77349,
    strokeMiterlimit: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.066 114.23H161.781",
    stroke: "black",
    strokeWidth: 1.77349,
    strokeMiterlimit: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.546 90.8618C161.086 93.4298 159.668 96.3809 159.427 99.4313C159.158 96.3809 157.754 93.4299 156.294 90.8477",
    stroke: "#090A0B",
    strokeWidth: 1.77349,
    strokeMiterlimit: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.352 85.173C201.843 79.5546 196.938 69.6372 191.508 63.7776C191.175 63.429 190.737 63.1997 190.261 63.125C187.836 62.8128 178.962 61.8906 159.413 61.8906C139.877 61.8906 131.003 62.8128 128.579 63.125C128.097 63.1959 127.657 63.4371 127.331 63.7776C121.902 69.6372 116.982 79.5546 114.487 85.173",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.352 85.173C201.843 79.5546 196.938 69.6372 191.508 63.7776C191.175 63.429 190.737 63.1997 190.261 63.125C187.836 62.8128 178.962 61.8906 159.413 61.8906C139.877 61.8906 131.003 62.8128 128.579 63.125C128.097 63.1959 127.657 63.4371 127.331 63.7776C121.902 69.6372 116.982 79.5546 114.487 85.173",
    stroke: "#090A0B",
    strokeWidth: 1.77349,
    strokeMiterlimit: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.589 85.2878C199.589 85.2878 193.762 73.753 188.886 67.8083C188.378 67.2154 187.673 66.8272 186.901 66.7158C184.023 66.4179 175.758 65.7227 159.413 65.7227C138.432 65.7227 130.748 66.8577 130.748 66.8577C125.744 72.4335 119.251 85.2878 119.251 85.2878C119.251 85.2878 137.34 81.3152 159.413 81.3152C181.5 81.3152 199.589 85.2878 199.589 85.2878V85.2878Z",
    stroke: "#090A0B",
    strokeWidth: 1.77349,
    strokeMiterlimit: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 146,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.dc3c9d1592013220d5a1ec3a33697499.svg";
export { ForwardRef as ReactComponent };